module.exports = __webpack_public_path__ + "static/media/ico_home.67a5275c.png";